<template>
  <button 
    class="button-link" 
    :class="{ 'with-icon': hasIcon }"
    @click="handleClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <img 
      v-if="iconSrc" 
      :src="iconSrc" 
      width="16" 
      height="16" 
      class="button-link-icon" 
    />
    <span class="button-link-text">
      {{ label }}
    </span>
    
    <AppTooltip 
      v-if="showTooltip && tooltipText" 
      :text="tooltipText" 
      :width="tooltipWidth" 
    />
  </button>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import AppTooltip from '@/components/ui-kit/tooltip/AppTooltip.vue';

export default defineComponent({
  name: 'LoginButtonLink',
  components: {
    AppTooltip
  },
  props: {
    label: {
      type: String,
      required: true
    },
    iconSrc: {
      type: String,
      default: ''
    },
    tooltipText: {
      type: String,
      default: ''
    },
    tooltipWidth: {
      type: Number,
      default: 186
    },
    showTooltipOnHover: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props, { emit }) {
    const showTooltip = ref(false);

    const hasIcon = computed(() => !!props.iconSrc);

    const handleClick = () => {
      emit('click');
    };

    const handleMouseEnter = () => {
      if (props.showTooltipOnHover && props.tooltipText) {
        showTooltip.value = true;
      }
    };

    const handleMouseLeave = () => {
      showTooltip.value = false;
    };

    return {
      showTooltip,
      hasIcon,
      handleClick,
      handleMouseEnter,
      handleMouseLeave
    };
  }
});
</script>

<style scoped>
.button-link {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 18px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #979797 !important;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.button-link:hover {
  cursor: pointer;
  text-decoration: underline;
}

.button-link.with-icon {
  gap: 4px;
}

.button-link-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.button-link-text {
  display: inline-block;
  color: #979797 !important;
}
</style>